module.exports = __webpack_public_path__ + "img/pd_D1.8.3.ea0416b1.png";